import { TranslationKeysMapper } from '@nimbus-library/features/localization/models/translation-keys.model';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';

export enum NimbusPermissionKey {
  AssistantTemplates = 'AssistantTemplates',
  BotTemplates = 'BotTemplates',
  CallerAnonymizationRegexes = 'CallerAnonymizationRegexes',
  CallSessionResources = 'CallSessionResources',
  ChangeHistory = 'ChangeHistory',
  ChatHandlerDomainTemplates = 'ChatHandlerDomainTemplates',
  ChatHandlerFileTypePolicies = 'ChatHandlerFileTypePolicies',
  ChatHandlerMessagingEntries = 'ChatHandlerMessagingEntries',
  ChatHandlerProviderConnectors = 'ChatHandlerProviderConnectors',
  // TODO: Rename to CustomerOverview after the BE update
  ReadCustomerOverview = 'ReadCustomerOverview',
  CustomRoles = 'CustomRoles',
  DashboardSharedAccessLinks = 'DashboardSharedAccessLinks',
  DistributionPolicies = 'DistributionPolicies',
  FeatureFlagVisibility = 'FeatureFlagVisibility',
  GlobalHeaderBar = 'GlobalHeaderBar',
  InstantMessaging = 'InstantMessaging',
  InteractTemplates = 'InteractTemplates',
  Mailboxes = 'Mailboxes',
  ManageDirectCallUserTracking = 'ManageDirectCallUserTracking',
  NotAvailableReasons = 'NotAvailableReasons',
  OpeningHours = 'OpeningHours',
  OpeningHoursPeriods = 'OpeningHoursPeriods',
  Policies = 'Policies',
  PresenceTracking = 'PresenceTracking',
  ResponsibilityProfiles = 'ResponsibilityProfiles',

  Services = 'Services',
  ServicesAssistant = 'ServicesAssistant',
  ServicesAssistantConversationContextsList = 'ServicesAssistantConversationContextsList',
  ServicesAssistantTemplatesList = 'ServicesAssistantTemplatesList',
  ServicesAttendantConsole = 'ServicesAttendantConsole',
  ServicesCodes = 'ServicesCodes',
  ServicesCodesList = 'ServicesCodesList',
  ServicesCompanion = 'ServicesCompanion',
  ServicesCompanionSpeechRecognizersList = 'ServicesCompanionSpeechRecognizersList',
  ServicesCompanionUnify = 'ServicesCompanionUnify',
  ServicesCompanionUnifyTranscriptionLocalesList = 'ServicesCompanionUnifyTranscriptionLocalesList',
  ServicesContextParametersList = 'ServicesContextParametersList',
  ServicesDataPrivacy = 'ServicesDataPrivacy',
  ServicesDataPrivacyCallerAnonymizationRegexesList = 'ServicesDataPrivacyCallerAnonymizationRegexesList',
  ServicesDataPrivacyFileTypePoliciesList = 'ServicesDataPrivacyFileTypePoliciesList',
  ServicesDistributionAcw = 'ServicesDistributionAcw',
  ServicesDistributionConversationsDistribution = 'ServicesDistributionConversationsDistribution',
  ServicesDistributionEmergencyRouting = 'ServicesDistributionEmergencyRouting',
  ServicesDistributionPersistentRona = 'ServicesDistributionPersistentRona',
  ServicesDistributionPoliciesList = 'ServicesDistributionPoliciesList',
  ServicesDistributionTaskPriority = 'ServicesDistributionTaskPriority',
  ServicesDistributionUsersAssignment = 'ServicesDistributionUsersAssignment',
  ServicesDistributionUsersDefaultEnability = 'ServicesDistributionUsersDefaultEnability',
  ServicesGeneral = 'ServicesGeneral',
  ServicesGeneralOrganizationUnit = 'ServicesGeneralOrganizationUnit',
  ServicesInteract = 'ServicesInteract',
  ServicesInteractDomainTemplatesList = 'ServicesInteractDomainTemplatesList',
  ServicesLicencesAndAddons = 'ServicesLicencesAndAddons',
  ServicesModalitiesGeneral = 'ServicesModalitiesGeneral',
  ServicesModalitiesAudioVideo = 'ServicesModalitiesAudioVideo',
  ServicesModalitiesInstantMessaging = 'ServicesModalitiesInstantMessaging',
  ServicesModalitiesInstantMessagingList = 'ServicesModalitiesInstantMessagingList',
  ServicesModalitiesWebChatDomainTemplatesList = 'ServicesModalitiesWebChatDomainTemplatesList',
  ServicesModalitiesExternalTask = 'ServicesModalitiesExternalTask',
  ServicesModalitiesEmail = 'ServicesModalitiesEmail',
  ServicesModalitiesEmailMailboxesList = 'ServicesModalitiesEmailMailboxesList',
  ServicesModalitiesMessagingEntriesList = 'ServicesModalitiesMessagingEntriesList',
  ServicesModalitiesSpeechRecognizersList = 'ServicesModalitiesSpeechRecognizersList',
  ServicesMySessionsConversationContextData = 'ServicesMySessionsConversationContextData',
  ServicesMySessionsConversationContextUrls = 'ServicesMySessionsConversationContextUrls',
  ServicesMySessionsKeepContextOnTransfer = 'ServicesMySessionsKeepContextOnTransfer',
  ServicesMySessionsWidgets = 'ServicesMySessionsWidgets',
  ServicesNimbusOneConversationContextUrls = 'ServicesNimbusOneConversationContextUrls',
  ServicesNimbusOneSessionParameters = 'ServicesNimbusOneSessionParameters',
  ServicesOpeningHours = 'ServicesOpeningHours',
  ServicesOpeningHoursList = 'ServicesOpeningHoursList',
  ServicesPermissionsMembers = 'ServicesPermissionsMembers',
  ServicesPermissionsMembersSkillsAndProfile = 'ServicesPermissionsMembersSkillsAndProfile',
  ServicesPermissionsUsersList = 'ServicesPermissionsUsersList',
  ServicesReportingSlaAndThresholds = 'ServicesReportingSlaAndThresholds',
  ServicesReportingVisibility = 'ServicesReportingVisibility',
  ServicesTasksList = 'ServicesTasksList',
  ServicesUsersDefaultTeamOwnerRole = 'ServicesUsersDefaultTeamOwnerRole',
  ServicesUsersList = 'ServicesUsersList',
  ServicesUsersListRoles = 'ServicesUsersListRoles',
  ServicesUsersListStates = 'ServicesUsersListStates',
  ServicesUsersTeamMemberCanChangeActiveState = 'ServicesUsersTeamMemberCanChangeActiveState',

  SkillCategories = 'SkillCategories',
  Skills = 'Skills',
  SkillsWithCategoriesList = 'SkillsWithCategoriesList',

  TenantDiagnosticLogging = 'TenantDiagnosticLogging',

  UiConfigurationProfiles = 'UiConfigurationProfiles',

  UserEffectiveSettings = 'UserEffectiveSettings',

  Users = 'Users',
  UsersAssistant = 'UsersAssistant',
  UsersAssistantTemplatesList = 'UsersAssistantTemplatesList',
  UsersDirectCallService = 'UsersDirectCallService',
  UsersGeneral = 'UsersGeneral',
  UsersGeneralOrganizationUnit = 'UsersGeneralOrganizationUnit',
  UsersInteract = 'UsersInteract',
  UsersInteractDomainTemplatesList = 'UsersInteractDomainTemplatesList',
  UsersInteractInstantMessagingList = 'UsersInteractInstantMessagingList',
  UsersLicencesAndModalities = 'UsersLicencesAndModalities',
  UsersNotAvailableReasons = 'UsersNotAvailableReasons',
  UsersNotAvailableReasonsList = 'UsersNotAvailableReasonsList',
  UsersResponsibilityProfiles = 'UsersResponsibilityProfiles',
  UsersResponsibilityProfilesList = 'UsersResponsibilityProfilesList',
  UsersRoles = 'UsersRoles',
  UsersServices = 'UsersServices',
  UsersSkillsAssignment = 'UsersSkillsAssignment',
  UsersSkillsLevels = 'UsersSkillsLevels',
  UsersSkillsWithCategoriesList = 'UsersSkillsWithCategoriesList',
  UsersUiAccess = 'UsersUiAccess',

  VirtualUserAuthenticationList = 'VirtualUserAuthenticationList',
  VirtualUsers = 'VirtualUsers',
  WebRequests = 'WebRequests',
  Workflows = 'Workflows',

  AuthorizedOrganizationUnitCanManageMarker = 'AuthorizedOrganizationUnitCanManageMarker',
  ViewAdminOperationsChangeHistoryMarker = 'ViewAdminOperationsChangeHistoryMarker',
  ViewAdminOperationsCustomersMarker = 'ViewAdminOperationsCustomersMarker',
  ViewAdminOperationsFeatureFlagVisibilityMarker = 'ViewAdminOperationsFeatureFlagVisibilityMarker',
  ViewAdminOperationsServicesMarker = 'ViewAdminOperationsServicesMarker',
  ViewAdminOperationsTaskManagementMarker = 'ViewAdminOperationsTaskManagementMarker',
  ViewAdminUserPreferencesMarker = 'ViewAdminUserPreferencesMarker',
  ViewAttendantConsoleMarker = 'ViewAttendantConsoleMarker',
  ViewConfigurationMarker = 'ViewConfigurationMarker',
  ViewFlexibleDashboardsMarker = 'ViewFlexibleDashboardsMarker',
  ViewMyOverviewMarker = 'ViewMyOverviewMarker',
  ViewMyServicesDashboardMarker = 'ViewMyServicesDashboardMarker',
  ViewMyServicesHistoricalReportingMarker = 'ViewMyServicesHistoricalReportingMarker',
  ViewMyServicesMyServicesMarker = 'ViewMyServicesMyServicesMarker',
  ViewMyServicesSettingsMarker = 'ViewMyServicesSettingsMarker',
  ViewMySessionsMarker = 'ViewMySessionsMarker',
  ViewTenantConsentTableMarker = 'ViewTenantConsentTableMarker',
  ViewUserPreferencesMarker = 'ViewUserPreferencesMarker',
  ViewUi = 'ViewUi',
}

export const NimbusPermissionKeyTranslateMap: TranslationKeysMapper<NimbusPermissionKey> = {
  AssistantTemplates: TranslationKeys.AdminCommonNimbusPermissionKeyAssistantTemplates,
  BotTemplates: TranslationKeys.AdminCommonNimbusPermissionKeyBotTemplates,
  CallerAnonymizationRegexes: TranslationKeys.AdminCommonNimbusPermissionKeyCallerAnonymizationRegexes,
  CallSessionResources: TranslationKeys.AdminCommonNimbusPermissionKeyCallSessionResources,
  ChangeHistory: TranslationKeys.AdminCommonNimbusPermissionKeyChangeHistory,
  ChatHandlerDomainTemplates: TranslationKeys.AdminCommonNimbusPermissionKeyChatHandlerDomainTemplates,
  ChatHandlerFileTypePolicies: TranslationKeys.AdminCommonNimbusPermissionKeyChatHandlerFileTypePolicies,
  ChatHandlerMessagingEntries: TranslationKeys.AdminCommonNimbusPermissionKeyChatHandlerMessagingEntries,
  ChatHandlerProviderConnectors: TranslationKeys.AdminCommonNimbusPermissionKeyChatHandlerProviderConnectors,
  ReadCustomerOverview: TranslationKeys.AdminCommonNimbusPermissionKeyCustomerOverview,
  CustomRoles: TranslationKeys.AdminCommonNimbusPermissionKeyCustomRoles,
  DashboardSharedAccessLinks: TranslationKeys.AdminCommonNimbusPermissionKeyDashboardSharedAccessLinks,
  DistributionPolicies: TranslationKeys.AdminCommonNimbusPermissionKeyDistributionPolicies,
  FeatureFlagVisibility: TranslationKeys.AdminCommonNimbusPermissionKeyFeatureFlagVisibility,
  GlobalHeaderBar: TranslationKeys.AdminCommonNimbusPermissionKeyGlobalHeaderBar,
  InstantMessaging: TranslationKeys.AdminCommonNimbusPermissionKeyInstantMessaging,
  InteractTemplates: TranslationKeys.AdminCommonNimbusPermissionKeyInteractTemplates,
  Mailboxes: TranslationKeys.AdminCommonNimbusPermissionKeyMailboxes,
  ManageDirectCallUserTracking: TranslationKeys.AdminCommonNimbusPermissionKeyManageDirectCallUserTracking,
  NotAvailableReasons: TranslationKeys.AdminCommonNimbusPermissionKeyNotAvailableReasons,
  OpeningHours: TranslationKeys.AdminCommonNimbusPermissionKeyOpeningHours,
  OpeningHoursPeriods: TranslationKeys.AdminCommonNimbusPermissionKeyOpeningHoursPeriods,
  Policies: TranslationKeys.AdminCommonNimbusPermissionKeyPolicies,
  PresenceTracking: TranslationKeys.AdminCommonNimbusPermissionKeyPresenceTracking,
  ResponsibilityProfiles: TranslationKeys.AdminCommonNimbusPermissionKeyResponsibilityProfiles,

  Services: TranslationKeys.AdminCommonNimbusPermissionKeyServicesList,
  ServicesAssistant: TranslationKeys.AdminCommonNimbusPermissionKeyServicesAssistant,
  ServicesAssistantConversationContextsList: TranslationKeys.AdminCommonNimbusPermissionKeyServicesAssistantConversationContextsList,
  ServicesAssistantTemplatesList: TranslationKeys.AdminCommonNimbusPermissionKeyServicesAssistantTemplatesList,
  ServicesAttendantConsole: TranslationKeys.AdminCommonNimbusPermissionKeyServicesAttendantConsole,
  ServicesCodes: TranslationKeys.AdminCommonNimbusPermissionKeyServicesCodes,
  ServicesCodesList: TranslationKeys.AdminCommonNimbusPermissionKeyServicesCodesList,
  ServicesCompanion: TranslationKeys.AdminCommonNimbusPermissionKeyServiceCompanionTab,
  ServicesCompanionSpeechRecognizersList: TranslationKeys.AdminCommonNimbusPermissionKeyServicesCompanionSpeechRecognizersList,
  ServicesCompanionUnify: TranslationKeys.AdminCommonNimbusPermissionKeyServicesCompanionUnify,
  ServicesCompanionUnifyTranscriptionLocalesList:
    TranslationKeys.AdminCommonNimbusPermissionKeyServicesCompanionUnifyTranscriptionLocalesList,
  ServicesContextParametersList: TranslationKeys.AdminCommonNimbusPermissionKeyServicesContextParametersList,
  ServicesDataPrivacy: TranslationKeys.AdminCommonNimbusPermissionKeyServicesDataPrivacy,
  ServicesDataPrivacyCallerAnonymizationRegexesList:
    TranslationKeys.AdminCommonNimbusPermissionKeyServicesDataPrivacyCallerAnonymizationRegexesList,
  ServicesDataPrivacyFileTypePoliciesList: TranslationKeys.AdminCommonNimbusPermissionKeyServicesDataPrivacyFileTypePoliciesList,
  ServicesDistributionAcw: TranslationKeys.AdminCommonNimbusPermissionKeyServicesDistributionAcw,
  ServicesDistributionConversationsDistribution:
    TranslationKeys.AdminCommonNimbusPermissionKeyServicesDistributionConversationsDistribution,
  ServicesDistributionEmergencyRouting: TranslationKeys.AdminCommonNimbusPermissionKeyServicesDistributionEmergencyRouting,
  ServicesDistributionPersistentRona: TranslationKeys.AdminCommonNimbusPermissionKeyServicesDistributionPersistentRona,
  ServicesDistributionPoliciesList: TranslationKeys.AdminCommonNimbusPermissionKeyServicesDistributionPoliciesList,
  ServicesDistributionTaskPriority: TranslationKeys.AdminCommonNimbusPermissionKeyServicesDistributionTaskPriority,
  ServicesDistributionUsersAssignment: TranslationKeys.AdminCommonNimbusPermissionKeyServicesDistributionUsersAssignment,
  ServicesDistributionUsersDefaultEnability: TranslationKeys.AdminCommonNimbusPermissionKeyServicesDistributionUsersDefaultEnability,
  ServicesGeneral: TranslationKeys.AdminCommonNimbusPermissionKeyServicesGeneral,
  ServicesGeneralOrganizationUnit: TranslationKeys.AdminCommonNimbusPermissionKeyServicesGeneralOrganizationUnit,
  ServicesInteract: TranslationKeys.AdminCommonNimbusPermissionKeyServicesInteract,
  ServicesInteractDomainTemplatesList: TranslationKeys.AdminCommonNimbusPermissionKeyServicesInteractDomainTemplatesList,
  ServicesLicencesAndAddons: TranslationKeys.AdminCommonNimbusPermissionKeyServicesLicencesAndAddons,
  ServicesModalitiesGeneral: TranslationKeys.AdminCommonNimbusPermissionKeyServicesModalitiesGeneral,
  ServicesModalitiesAudioVideo: TranslationKeys.AdminCommonNimbusPermissionKeyServicesModalitiesAudioVideo,
  ServicesModalitiesInstantMessaging: TranslationKeys.AdminCommonNimbusPermissionKeyServicesModalitiesInstantMessaging,
  ServicesModalitiesInstantMessagingList: TranslationKeys.AdminCommonNimbusPermissionKeyServicesModalitiesInstantMessagingList,
  ServicesModalitiesExternalTask: TranslationKeys.AdminCommonNimbusPermissionKeyServicesModalitiesExternalTask,
  ServicesModalitiesEmail: TranslationKeys.AdminCommonNimbusPermissionKeyServicesModalitiesEmail,
  ServicesModalitiesEmailMailboxesList: TranslationKeys.AdminCommonNimbusPermissionKeyServicesModalitiesEmailMailboxesList,
  ServicesModalitiesMessagingEntriesList: TranslationKeys.AdminCommonNimbusPermissionKeyServicesModalitiesMessagingEntriesList,
  ServicesModalitiesSpeechRecognizersList: TranslationKeys.AdminCommonNimbusPermissionKeyServicesModalitiesSpeechRecognizersList,
  ServicesModalitiesWebChatDomainTemplatesList: TranslationKeys.AdminCommonNimbusPermissionKeyServicesModalitiesWebChatDomainTemplatesList,
  ServicesMySessionsConversationContextData: TranslationKeys.AdminCommonNimbusPermissionKeyServicesMySessionsConversationContextData,
  ServicesMySessionsConversationContextUrls: TranslationKeys.AdminCommonNimbusPermissionKeyServicesMySessionsConversationContextUrls,
  ServicesMySessionsKeepContextOnTransfer: TranslationKeys.AdminCommonNimbusPermissionKeyServicesMySessionsKeepContextOnTransfer,
  ServicesMySessionsWidgets: TranslationKeys.AdminCommonNimbusPermissionKeyServicesMySessionsWidgets,
  ServicesNimbusOneConversationContextUrls: TranslationKeys.AdminCommonNimbusPermissionKeyServicesNimbusOneConversationContextUrls,
  ServicesNimbusOneSessionParameters: TranslationKeys.AdminCommonNimbusPermissionKeyServicesNimbusOneSessionParameters,
  ServicesOpeningHours: TranslationKeys.AdminCommonNimbusPermissionKeyServicesOpeningHours,
  ServicesOpeningHoursList: TranslationKeys.AdminCommonNimbusPermissionKeyServicesOpeningHoursList,
  ServicesPermissionsMembers: TranslationKeys.AdminCommonNimbusPermissionKeyServicesPermissionsMembers,
  ServicesPermissionsMembersSkillsAndProfile: TranslationKeys.AdminCommonNimbusPermissionKeyServicesPermissionsMembersSkillsAndProfile,
  ServicesPermissionsUsersList: TranslationKeys.AdminCommonNimbusPermissionKeyServicesPermissionsUsersList,
  ServicesReportingSlaAndThresholds: TranslationKeys.AdminCommonNimbusPermissionKeyServicesReportingSlaAndThresholds,
  ServicesReportingVisibility: TranslationKeys.AdminCommonNimbusPermissionKeyServicesReportingVisibility,
  ServicesTasksList: TranslationKeys.AdminCommonNimbusPermissionKeyServicesTasksList,
  ServicesUsersDefaultTeamOwnerRole: TranslationKeys.AdminCommonNimbusPermissionKeyServicesUsersDefaultTeamOwnerRole,
  ServicesUsersList: TranslationKeys.AdminCommonNimbusPermissionKeyServicesUsersList,
  ServicesUsersListRoles: TranslationKeys.AdminCommonNimbusPermissionKeyServicesUsersListRoles,
  ServicesUsersListStates: TranslationKeys.AdminCommonNimbusPermissionKeyServicesUsersListStates,
  ServicesUsersTeamMemberCanChangeActiveState: TranslationKeys.AdminCommonNimbusPermissionKeyServicesUsersTeamMemberCanChangeActiveState,

  SkillCategories: TranslationKeys.AdminCommonNimbusPermissionKeySkillCategories,
  Skills: TranslationKeys.AdminCommonNimbusPermissionKeySkills,
  SkillsWithCategoriesList: TranslationKeys.AdminCommonNimbusPermissionKeySkillsWithCategoriesList,

  TenantDiagnosticLogging: null,

  UserEffectiveSettings: TranslationKeys.AdminCommonNimbusPermissionKeyUserEffectiveSettings,

  Users: TranslationKeys.AdminCommonNimbusPermissionKeyUsersList,
  UsersAssistant: TranslationKeys.AdminCommonNimbusPermissionKeyUsersAssistant,
  UsersAssistantTemplatesList: TranslationKeys.AdminCommonNimbusPermissionKeyUsersAssistantTemplatesList,
  UsersDirectCallService: TranslationKeys.AdminCommonNimbusPermissionKeyUsersDirectCallService,
  UsersGeneral: TranslationKeys.AdminCommonNimbusPermissionKeyUsersGeneral,
  UsersGeneralOrganizationUnit: TranslationKeys.AdminCommonNimbusPermissionKeyUsersGeneralOrganizationUnit,
  UsersInteract: TranslationKeys.AdminCommonNimbusPermissionKeyUsersInteract,
  UsersInteractDomainTemplatesList: TranslationKeys.AdminCommonNimbusPermissionKeyUsersInteractDomainTemplatesList,
  UsersInteractInstantMessagingList: TranslationKeys.AdminCommonNimbusPermissionKeyUsersInteractInstantMessagingList,
  UsersLicencesAndModalities: TranslationKeys.AdminCommonNimbusPermissionKeyUsersLicencesAndModalities,
  UsersNotAvailableReasons: TranslationKeys.AdminCommonNimbusPermissionKeyUsersNotAvailableReasons,
  UsersNotAvailableReasonsList: TranslationKeys.AdminCommonNimbusPermissionKeyUsersNotAvailableReasonsList,
  UsersResponsibilityProfiles: TranslationKeys.AdminCommonNimbusPermissionKeyUsersResponsibilityProfiles,
  UsersResponsibilityProfilesList: TranslationKeys.AdminCommonNimbusPermissionKeyUsersResponsibilityProfilesList,
  UsersRoles: TranslationKeys.AdminCommonNimbusPermissionKeyUsersRoles,
  UsersServices: TranslationKeys.AdminCommonNimbusPermissionKeyUsersServices,
  UsersSkillsAssignment: TranslationKeys.AdminCommonNimbusPermissionKeyUsersSkillsAssignment,
  UsersSkillsLevels: TranslationKeys.AdminCommonNimbusPermissionKeyUsersSkillsLevels,
  UsersSkillsWithCategoriesList: TranslationKeys.AdminCommonNimbusPermissionKeyUsersSkillsWithCategoriesList,
  UsersUiAccess: TranslationKeys.AdminCommonNimbusPermissionKeyUsersUiAccess,

  UiConfigurationProfiles: TranslationKeys.AdminCommonNimbusPermissionKeyUiConfigurationProfiles,

  VirtualUserAuthenticationList: TranslationKeys.AdminCommonNimbusPermissionKeyVirtualUserAuthenticationList,
  VirtualUsers: TranslationKeys.AdminCommonNimbusPermissionKeyVirtualUsers,
  WebRequests: null,
  Workflows: TranslationKeys.AdminCommonNimbusPermissionKeyWorkflows,

  AuthorizedOrganizationUnitCanManageMarker: null,
  ViewAdminOperationsChangeHistoryMarker: null,
  ViewAdminOperationsCustomersMarker: null,
  ViewAdminOperationsFeatureFlagVisibilityMarker: null,
  ViewAdminOperationsServicesMarker: null,
  ViewAdminOperationsTaskManagementMarker: null,
  ViewAdminUserPreferencesMarker: null,
  ViewAttendantConsoleMarker: null,
  ViewConfigurationMarker: null,
  ViewFlexibleDashboardsMarker: null,
  ViewMyOverviewMarker: null,
  ViewMyServicesDashboardMarker: null,
  ViewMyServicesHistoricalReportingMarker: null,
  ViewMyServicesMyServicesMarker: null,
  ViewMyServicesSettingsMarker: null,
  ViewMySessionsMarker: null,
  ViewTenantConsentTableMarker: null,
  ViewUserPreferencesMarker: null,
  ViewUi: null,
};
